export default "__VITE_ASSET__C10n6oue__"